export const formatarDataBR = (dataRaw: string | Date) => {
  if (!dataRaw) return '-';
  const d = new Date(dataRaw);
  const dia = String(d.getUTCDate()).padStart(2, '0');
  const mes = String(d.getUTCMonth() + 1).padStart(2, '0');
  const ano = d.getUTCFullYear();
  return `${dia}/${mes}/${ano}`;
};


const formatosNumero = new Map<number, Intl.NumberFormat>();

// Número em pt-BR (milhar com ponto, decimal com vírgula). "n/d" quando o
// valor não é numérico (null, undefined, '', NaN).
export const formatarNumero = (valor: unknown, casas = 1): string => {
  if (valor === null || valor === undefined || valor === '') return 'n/d';
  const n = typeof valor === 'number' ? valor : Number(valor);
  if (!Number.isFinite(n)) return 'n/d';
  let fmt = formatosNumero.get(casas);
  if (!fmt) {
    fmt = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas });
    formatosNumero.set(casas, fmt);
  }
  return fmt.format(n);
};

export const formatarKg = (valor: unknown): string => formatarNumero(valor, 1);

export const formatarRendimento = (valor: unknown): string => formatarNumero(valor, 2);
